import React, { useState, useEffect } from 'react'
import { Table, Button, Badge, Dropdown, DropdownToggle, DropdownItem, DropdownMenu, InputGroup, InputGroupText, Input, Form, } from 'reactstrap';
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import PrivateSeller from './PrivateSeller';
import BesinessSeller from './BusinessSeller'
import './../../components/Components.css'

export default function Seller() {
    const [sellerType, setSellerType] = useState('')
    const [artikelnummer, setArtikelnummer] = useState('')
    const [price, setPrice] = useState('')
    const [desc, setDesc] = useState('')
    let newTableinfo;
    const [privateSellerInfo, setPrivateSellerInfo] = useState({
        fName: '',
        lName: '',
        address: '',
        ZipCode: '',
        city: '',
        country: '',
        email: '',
        phone: ''
    })
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [adress, setAdress] = useState('')
    const [zipcode, setZipCode] = useState('')
    const [city, setCity] = useState('')
    const [country, setCountry] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [addressLine2, setAddressLine2] = useState('')

    const [kontoinhaber, setKontoinhaber] = useState('')
    const [iban, setIban] = useState('')
    const [bic, setBic] = useState('')
    const [nameDerBank, setNameDerBank] = useState('')

    const [bSellerdropdownValue, setBSellerDropdownValue] = useState("Please Select the Seller Name");
    const [businessSellerContactData, setBusinessSellerContactData] = useState([]);
    const [bSellerComponentReset, setBSellerComponentReset] = useState(true)


    const [tableData, setTableData] = useState([]);
    const [tableData2, set2TableData] = useState([])

    const [brandNames, setBrandNames] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdowntoggle = () =>
        setDropdownOpen((prevState) => !prevState);
    const [brandDropdownValue, setBrandDropdownValue] = useState("Marke auswählen");
    const removeItem = (indexOfItem) => {
        var copyOfTableData = [...tableData];
        if (indexOfItem !== -1) {
            copyOfTableData.splice(indexOfItem, 1);
            setTableData(copyOfTableData);
        }
    }


    const reasetData = () => {
        setArtikelnummer('')
        setPrice('')
        setDesc('')
        setFirstName('')
        setLastName('')
        setAdress('')
        setZipCode('')
        setCity('')
        setCountry('')
        setEmail('')
        setPhone('')
        setCompanyName('')
        setAddressLine2('')
        setKontoinhaber('')
        setIban('')
        setBic('')
        setNameDerBank('')
        setBSellerComponentReset(!bSellerComponentReset)
    }
    const handleAddItemToList = (brand, artikelnummer, price, desc) => {
        console.log(tableData)
        if ( brand === 'Marke auswählen' || !brand) {
            alert("Bitte füllen Sie die Pflichtfelder aus")
        } else {
            let copy = tableData;
            copy.push({ brand: brand, description: desc, artikelnummer: artikelnummer, price: price });
            setTableData(copy)
            newTableinfo = tableData.map((item, index) => {
                return (
                    <tr key={index}>
                        <td >{item.brand}</td>
                        <td >{item.description}</td>
                        <td >{item.artikelnummer}</td>
                        <td >{item.price}</td>
                        <td ><Button onClick={() => { removeItem(index) }} style={{ display: 'block', marginLeft: 'auto' }} outline color='danger'>Remove</Button></td>
                    </tr>
                )
            })
            set2TableData(newTableinfo)
            setArtikelnummer('')
            setBrandDropdownValue("Marke auswählen")
            setPrice('')
            setDesc('')
            setRoleValue('')
        }
    }


    const handleSaveListBtn = async () => {
        try {
            console.log(sellerType, companyName, iban, bic, kontoinhaber, firstName, lastName, zipcode)
            if (sellerType === '') {
                alert("Bitte wählen Sie den Verkäufertyp")
            } else
                if (firstName === '' && lastName === '') {
                    alert("Bitte geben Sie den Nachnamen des privaten Verkäufers an oder wenn es sich um einen gewerblichen Verkäufer handelt, wählen Sie diesen aus.")
                } else
                    if (tableData.length === 0) {
                        alert("Bitte fügen Sie den Listen zunächst einen oder mehrere Einträge hinzu")
                    } else {
                        console.log(tableData)
                        let payload = []
                        payload = tableData.map((item, index) => {
                            return (
                                {
                                    "Title": item.description ? item.description : '',
                                    "Brand": item.brand,
                                    "ArticleNo": item.artikelnummer,
                                    "Checkout": {
                                        "ArticlePrice": {
                                            "Amount": item.price ? item.price : '0',
                                            "Currency": "EUR"
                                        },
                                        "PaymentPurpose": `${iban}|${bic}|${kontoinhaber}`
                                    },
                                    "SellerInfo": {
                                        "SellerType": sellerType,
                                        "companyName": sellerType === "Dealer" ? companyName : '',
                                        "FirstName": firstName,
                                        "LastName": lastName,
                                        "phone": phone,
                                        "email": email,
                                        "AddressLine1": adress,
                                        "AddressLine2": addressLine2,
                                        "city": city,
                                        "CountryCode": country,
                                        "ZipCode": zipcode
                                    }
                                }
                            )
                        })
                        console.log(payload)
                        const response = await fetch(
                            "/api/Watches/DirectPurchase",
                            {
                                method: "POST",
                                headers: new Headers({
                                    "Content-Type": "application/json",
                                }),
                                body: JSON.stringify(payload),
                            }
                        );
                        if (!response.ok) {
                            alert(response.statusText, response.status, response.text());
                        }
                        if (response.ok) {
                            console.log("done")
                            console.log("response.text():", response.text())
                            setTableData([])
                            reasetData()
                            window.location.reload();
                        }
                    }
        } catch (e) {
            console.log(e);
        }
    };


    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            borderBottom: '1px dotted pink',
            color: state.isSelected ? 'red' : 'blue',
            padding: 5
        })
    }


    var optionalBrands
    const options = []


    const [realoptions, setRealptions] = useState()

 

    const handleChange = (field, value) => {
        switch (field) {
            case 'roles':
                setRoleValue(value)
                break

            default:
                break
        }
    }

    const [roleValue, setRoleValue] = useState('')    

    const getBrandNames = async () => {
        try {
            const response = await fetch(
                "/api/watches/brands",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            setBrandNames(payload);
            optionalBrands = payload.map((item, index) => {
                options.push({ value: index, label: item })
                setRealptions(options)
            })
            console.log(options)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getBrandNames();
    }, [])
    return (
        <div className="container mr-auto ml-3">
            <Badge className="mb-4" variant="info">
                <h1 className="h3">Zeitauktion Direktankauf</h1>
            </Badge>
            <hr />
            <div className="d-flex justify-content-between" style={{ width: "60%" }}>
                <h6>Bitte wählen Sie den Verkäufertyp aus:*</h6>
                <div>
                    <input className="mr-1" type="radio" id="bS" name="Seller" value=""
                        onClick={() => { setSellerType('Dealer'); reasetData() }} />
                    <label htmlFor="bS"><b>Geschäftlicher</b> Verkäufer</label>
                </div>
                <div>
                    <input className="mr-1" type="radio" id="pS" name="Seller" value=""
                        onClick={() => { setSellerType('PrivateSeller'); reasetData() }}
                    />
                    <label htmlFor="pS"><b>Privat</b>verkäufer</label>
                </div>
            </div>
            <hr />
            {(sellerType === 'Dealer') &&
                <BesinessSeller
                    setFirstName={setFirstName}
                    firstName={firstName}
                    setLastName={setLastName}
                    lastName={lastName}
                    setAdress={setAdress}
                    adress={adress}
                    setZipCode={setZipCode}
                    zipcode={zipcode}
                    setCity={setCity}
                    city={city}
                    setCountry={setCountry}
                    country={country}
                    setEmail={setEmail}
                    email={email}
                    setPhone={setPhone}
                    phone={phone}
                    setCompanyName={setCompanyName}
                    companyName={companyName}
                    setAddressLine2={setAddressLine2}
                    addressLine2={addressLine2}
                    setKontoinhaber={setKontoinhaber}
                    kontoinhaber={kontoinhaber}
                    setIban={setIban}
                    iban={iban}
                    setBic={setBic}
                    bic={bic}
                    bSellerComponentReset={bSellerComponentReset}
                    setNameDerBank={setNameDerBank}
                    nameDerBank={nameDerBank}
                />
            }
            {(sellerType === 'PrivateSeller') &&
                <PrivateSeller
                    setPrivateSellerInfo={setPrivateSellerInfo}
                    privateSellerInfo={privateSellerInfo}
                    setFirstName={setFirstName}
                    firstName={firstName}
                    setLastName={setLastName}
                    lastName={lastName}
                    setAdress={setAdress}
                    adress={adress}
                    setZipCode={setZipCode}
                    zipcode={zipcode}
                    setCity={setCity}
                    city={city}
                    setCountry={setCountry}
                    country={country}
                    setEmail={setEmail}
                    email={email}
                    setPhone={setPhone}
                    phone={phone}
                    setAddressLine2={setAddressLine2}
                    addressLine2={addressLine2}
                    setKontoinhaber={setKontoinhaber}
                    kontoinhaber={kontoinhaber}
                    setIban={setIban}
                    iban={iban}
                    setBic={setBic}
                    bic={bic}
                    setNameDerBank={setNameDerBank}
                    nameDerBank={nameDerBank}
                />
            }
            <hr />
            <h5 className="mb-4">Informationen zur Uhr</h5>
            <Form>
                <div className="d-flex justify-content-between mb-2">
                    {/* <Dropdown className="mr-5"
                        isOpen={dropdownOpen}
                        toggle={dropdowntoggle}>
                        <DropdownToggle caret>
                            {brandDropdownValue}
                        </DropdownToggle>
                        <DropdownMenu style={{ maxHeight: '500px', overflow: 'auto' }}>
                            {brandNames.map((brand, index) => {
                                return (
                                    <DropdownItem key={index} onClick={() => { setBrandDropdownValue(brand) }}>
                                        {brand}
                                    </DropdownItem>
                                )
                            })}
                        </DropdownMenu>
                        </Dropdown> */}

                    <div className='input d-flex w-75 mr-5'>
                        <Select 
                        className='w-100'
                            isClearable
                            onChange={(value) => handleChange('roles', value)}
                            options={realoptions}
                            value={roleValue}
                            styles={customStyles}
                            placeholder="Marke auswählen*"
                        />
                        
                    </div>
                    <InputGroup className="mr-5">
                        <InputGroupText>
                            Artikelnummer:
                        </InputGroupText>
                        <Input
                            value={artikelnummer}
                            onChange={e => setArtikelnummer(e.target.value)}
                            className="h-auto"
                        />
                    </InputGroup>
                    <InputGroup>
                        <InputGroupText>
                            Preis:
                        </InputGroupText>
                        <Input
                            type="number"
                            //min="-9999" max="9999"
                           // maxLength="4"
                           // pattern={[0-9]|[0-9]|[0-9]|[0-9]|[0-9]}
                            value={price}
                            onInput={e => e.target.value = e.target.value.slice(0, 5)}
                            onChange={e => setPrice(e.target.value)}
                            className="h-auto" 
                            />
                    </InputGroup>
                </div>
                <div className="d-flex mb-4">
                    <InputGroup className="mr-5">
                        <InputGroupText>
                            Beschreibung:
                        </InputGroupText>
                        <Input
                            value={desc}
                            onChange={e => setDesc(e.target.value)}
                            className="h-auto" />
                    </InputGroup>
                    <Button
                        onClick={() => { roleValue ? handleAddItemToList(roleValue.label, artikelnummer, price, desc) : alert("Marke auswählen")}}
                        className="text-nowrap">zur Liste hinzufügen</Button>
                </div>
                <hr />
                <h5 className="mb-4">Einkaufsliste</h5>
                <Table bordered striped hover>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>Marke</th>
                            <th style={{ width: "50%" }}>Beschreibung</th>
                            <th style={{ width: "10%" }}>Artikelnummer</th>
                            <th style={{ width: "10%" }}>Preis</th>
                            <th style={{ width: "10%" }}>Bearbeiten</th>

                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td >{item.brand}</td>
                                    <td >{item.description}</td>
                                    <td >{item.artikelnummer}</td>
                                    <td >{item.price}</td>
                                    <td ><Button onClick={() => { removeItem(index) }} style={{ display: 'block', marginLeft: 'auto' }} outline color='danger'>Remove</Button></td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                    <tbody style={{ display: "none" }}>
                        {tableData2}
                    </tbody>
                </Table>
                <Button
                    onClick={() => { handleSaveListBtn() }}
                    style={{ display: 'block', marginLeft: 'auto', fontWeight: '500' }}
                    outline color="success"
                >Die Liste speichern</Button>
            </Form>
        </div>
    )
}